// Registry central de íconos astrológicos (SVG recoloreables vía currentColor).
// Reemplaza a la fuente Astronomicon. Resuelve por nombre bilingüe (es/en) y
// expone helpers para planetas, signos y aspectos + un componente <AstroGlyph>
// para uso en contexto HTML (listas, tablas).
import React from 'react';

// --- Planetas ---------------------------------------------------------------
import { ReactComponent as IcSol } from '../assets/icons/Planets/Sol.svg';
import { ReactComponent as IcLuna } from '../assets/icons/Planets/Luna.svg';
import { ReactComponent as IcMercurio } from '../assets/icons/Planets/Mercurio.svg';
import { ReactComponent as IcVenus } from '../assets/icons/Planets/Venus.svg';
import { ReactComponent as IcMarte } from '../assets/icons/Planets/Marte.svg';
import { ReactComponent as IcJupiter } from '../assets/icons/Planets/Júpiter.svg';
import { ReactComponent as IcSaturno } from '../assets/icons/Planets/Saturno.svg';
import { ReactComponent as IcUrano } from '../assets/icons/Planets/Urano.svg';
import { ReactComponent as IcNeptuno } from '../assets/icons/Planets/Neptuno.svg';
import { ReactComponent as IcPluton } from '../assets/icons/Planets/Plutón.svg';
import { ReactComponent as IcQuiron } from '../assets/icons/Planets/Quirón.svg';
import { ReactComponent as IcLilith } from '../assets/icons/Planets/Lilith.svg';
import { ReactComponent as IcNodoNorte } from '../assets/icons/Planets/NodoNorte.svg';
import { ReactComponent as IcNodoSur } from '../assets/icons/Planets/NodoSur.svg';
import { ReactComponent as IcAscendente } from '../assets/icons/Planets/Ascendente.svg';
import { ReactComponent as IcMedioCielo } from '../assets/icons/Planets/MedioCielo.svg';
import { ReactComponent as IcRx } from '../assets/icons/Planets/Rx.svg';

// --- Signos -----------------------------------------------------------------
import { ReactComponent as IcAries } from '../assets/icons/Signs/Aries.svg';
import { ReactComponent as IcTauro } from '../assets/icons/Signs/Tauro.svg';
import { ReactComponent as IcGeminis } from '../assets/icons/Signs/Géminis.svg';
import { ReactComponent as IcCancer } from '../assets/icons/Signs/Cáncer.svg';
import { ReactComponent as IcLeo } from '../assets/icons/Signs/Leo.svg';
import { ReactComponent as IcVirgo } from '../assets/icons/Signs/Virgo.svg';
import { ReactComponent as IcLibra } from '../assets/icons/Signs/Libra.svg';
import { ReactComponent as IcEscorpio } from '../assets/icons/Signs/Escorpio.svg';
import { ReactComponent as IcSagitario } from '../assets/icons/Signs/Sagitario.svg';
import { ReactComponent as IcCapricornio } from '../assets/icons/Signs/Capricornio.svg';
import { ReactComponent as IcAcuario } from '../assets/icons/Signs/Acuario.svg';
import { ReactComponent as IcPiscis } from '../assets/icons/Signs/Piscis.svg';

// --- Aspectos ---------------------------------------------------------------
import { ReactComponent as IcConjuncion } from '../assets/icons/Aspects/Conjuncion.svg';
import { ReactComponent as IcSemiSextil } from '../assets/icons/Aspects/SemiSextil.svg';
import { ReactComponent as IcSextil } from '../assets/icons/Aspects/Sextil.svg';
import { ReactComponent as IcCuadratura } from '../assets/icons/Aspects/Cuadratura.svg';
import { ReactComponent as IcTrigono } from '../assets/icons/Aspects/Trigono.svg';
import { ReactComponent as IcQuincuncio } from '../assets/icons/Aspects/Quincuncio.svg';
import { ReactComponent as IcOposicion } from '../assets/icons/Aspects/Oposicion.svg';

// Mapa planeta -> componente (claves bilingües + AC/MC).
export const PLANET_ICONS = {
  Sol: IcSol, Sun: IcSol,
  Luna: IcLuna, Moon: IcLuna,
  Mercurio: IcMercurio, Mercury: IcMercurio,
  Venus: IcVenus,
  Marte: IcMarte, Mars: IcMarte,
  'Júpiter': IcJupiter, Jupiter: IcJupiter,
  Saturno: IcSaturno, Saturn: IcSaturno,
  Urano: IcUrano, Uranus: IcUrano,
  Neptuno: IcNeptuno, Neptune: IcNeptuno,
  'Plutón': IcPluton, Pluto: IcPluton,
  'Quirón': IcQuiron, Chiron: IcQuiron,
  Lilith: IcLilith,
  'Nodo Norte': IcNodoNorte, 'North Node': IcNodoNorte,
  'Nodo Sur': IcNodoSur, 'South Node': IcNodoSur,
  Ascendente: IcAscendente, Ascendant: IcAscendente,
  MC: IcMedioCielo, 'Medio Cielo': IcMedioCielo, Midheaven: IcMedioCielo,
  Rx: IcRx, retrogrado: IcRx, Retrograde: IcRx,
};

// Signos en orden zodiacal (índice 0 = Aries ... 11 = Piscis).
export const SIGN_ICONS_ORDER = [
  IcAries, IcTauro, IcGeminis, IcCancer, IcLeo, IcVirgo,
  IcLibra, IcEscorpio, IcSagitario, IcCapricornio, IcAcuario, IcPiscis,
];

// Mapa signo -> componente (claves bilingües).
export const SIGN_ICONS = {
  Aries: IcAries,
  Tauro: IcTauro, Taurus: IcTauro,
  'Géminis': IcGeminis, Gemini: IcGeminis,
  'Cáncer': IcCancer, Cancer: IcCancer,
  Leo: IcLeo,
  Virgo: IcVirgo,
  Libra: IcLibra,
  Escorpio: IcEscorpio, Scorpio: IcEscorpio,
  Sagitario: IcSagitario, Sagittarius: IcSagitario,
  Capricornio: IcCapricornio, Capricorn: IcCapricornio,
  Acuario: IcAcuario, Aquarius: IcAcuario,
  Piscis: IcPiscis, Pisces: IcPiscis,
};

// Mapa aspecto (key canónica de utils/aspectos) -> componente.
export const ASPECT_ICONS = {
  conjuncion: IcConjuncion,
  semisextil: IcSemiSextil,
  sextil: IcSextil,
  cuadratura: IcCuadratura,
  trigono: IcTrigono,
  quincuncio: IcQuincuncio,
  oposicion: IcOposicion,
};

export const getPlanetIcon = (nombre) => PLANET_ICONS[nombre] || null;
export const getSignIcon = (nombre) => SIGN_ICONS[nombre] || null;
export const getSignIconByIndex = (index) => SIGN_ICONS_ORDER[index] || null;
export const getAspectIcon = (key) => ASPECT_ICONS[key] || null;

// Glifo para contexto HTML (listas, tablas). Hereda el color vía currentColor;
// el tamaño se controla con CSS (clase .astro-glyph) o por prop style/size.
export function AstroGlyph({ kind, name, index, className = '', size, style, ...rest }) {
  let Comp = null;
  if (kind === 'planet') Comp = getPlanetIcon(name);
  else if (kind === 'sign') Comp = index != null ? getSignIconByIndex(index) : getSignIcon(name);
  else if (kind === 'aspect') Comp = getAspectIcon(name);
  if (!Comp) return null;
  const sizeStyle = size != null ? { width: size, height: size } : null;
  return (
    <Comp
      className={`astro-glyph ${className}`.trim()}
      style={{ ...sizeStyle, ...style }}
      {...rest}
    />
  );
}
